import { render, staticRenderFns } from "./UserProfileNewUserReferral.vue?vue&type=template&id=0c40a100"
import script from "./UserProfileNewUserReferral.vue?vue&type=script&lang=js"
export * from "./UserProfileNewUserReferral.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports